import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {ExemptionBaseComponent} from "../../common/exemption_base/exemption_base.component";
import {ExemptionGeneral} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
    selector: 'app-visit-exemptions-exemption-general',
    templateUrl: './exemption_general.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExemptionGeneralComponent extends ExemptionBaseComponent {
  @Input() exemption: ExemptionGeneral;
}

